import * as React from 'react';
import { connect } from 'react-redux';
import { Image } from 'react-bootstrap';
import { isMobile } from "react-device-detect";
import './SelfInspection.css';
import { CAPTURE_IMAGES, DASHBOARD, PERSONAL_INSURANCE } from '../../../routes/routes';
import KPBreadCrumb from '../../KPBreadCrumb/KPBreadCrumb';
import { getSelfInspectPhotos } from '../../../actions/selfInspectActions';
import { navigateTo } from '../../../actions/navigationActions';
import { showCallMeModal, showSendContinueOnPhone } from '../../../actions/modalActions';
import { SA_COUNTRY_ID } from '../../../constants/internationalization';
import NeedHelp from '../../BaseTemplate/SSPCustomComponentLibrary/NeedHelp/NeedHelp';

class MonthlyMileageDashboard extends React.Component<any, any> {

    constructor(props) {
        super(props);

        this.state = {

        }
        this.handleClick = this.handleClick.bind(this);
        this.handleStartSelfinspection = this.handleStartSelfinspection.bind(this);
        this.handleContinueMobile = this.handleContinueMobile.bind(this);
    }

    async handleContinueMobile() {
        this.props.dispatchShowSendContinueOnPhone(this.props.profile.cellphoneNumber, true);
    }

    componentDidMount() {

    }

    handleClick(id) {
        this.props.dispatchSetSelectedCover(id);
    }

    handleStartSelfinspection() {
        this.props.redirectTo((CAPTURE_IMAGES))
    }

    render() {
        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: PERSONAL_INSURANCE, description: "Personal insurance" }, { destination: PERSONAL_INSURANCE, description: "Car" }]

        if (this.props.selfInspect.selectedPersonalCover && this.props.selfInspect.selectedPersonalCover.product === 7) {
            BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: PERSONAL_INSURANCE, description: "Personal insurance" }, { destination: PERSONAL_INSURANCE, description: "Motorbike" }]
        }

        return (
            <div id="SelfInspectionLanding" className="container-fluid">
                <div className="new-breadcrumbwrapper selfinspection-landing-breadcrumb-wrapper">
                    <KPBreadCrumb navList={BreadcrumbDetails} activePage="Self-inspection" />
                </div>

                <div className="row self-inspect-main-row">
                    <div className="self-inspect-col-left">
                        <div id="SelfInspectionHeader" className="StepBox">
                            <h2>Self-inspection</h2>
                            <p>Without an inspection the king can't cover you properly. So why not just self-inspect</p>
                        </div>
                        {isMobile &&
                            <div id="PremiumBreakdown" className="self-inspect-start-mobile">
                                <button className="btn btn-solid-red w-100" onClick={() => this.props.dispatchGetSelfInspectPhotos()}>Start self-inspection</button>
                            </div>
                        }
                        <div id="SelfInspectionContent" className="StepBox">
                            <h2>How to self-inspect</h2>
                            <div className="row self-inspect-howto-row align-items-center">
                                <div className="self-inspect-howto-icon-col">
                                    <div className="align-middle self-inspect-icon self-inspect1"></div>
                                </div>
                                <div className="col self-inspect-howto-col">
                                    <p>Get a clear view</p>
                                </div>
                            </div>

                            <div className="row self-inspect-howto-row align-items-center">
                                <div className="self-inspect-howto-icon-col">
                                    <div className="align-middle self-inspect-icon self-inspect2"></div>
                                </div>
                                <div className="col self-inspect-howto-col">
                                    <p className="self-inspect-howto-well-lit">
                                        Make sure the location is
                                        <span className="selfinspect-howto-iphoneplus-textspace">
                                            &nbsp;
                                        </span>
                                        <br className="selfinspect-howto-iphoneplus-br" />
                                        well-lit
                                    </p>
                                </div>
                            </div>

                            <div className="row self-inspect-howto-row align-items-center">
                                <div className="self-inspect-howto-icon-col">
                                    <div className="align-middle self-inspect-icon self-inspect3"></div>
                                </div>
                                <div className="col self-inspect-howto-col">
                                    <p>Check your camera’s focus</p>
                                </div>
                            </div>

                            <div className="row self-inspect-howto-row align-items-center">
                                <div className="self-inspect-howto-icon-col">
                                    <div className="align-middle self-inspect-icon self-inspect4"></div>
                                </div>
                                <div className="col self-inspect-howto-col">
                                    <p>Make sure your car/motorbike is clearly visible in your photos</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {!isMobile &&
                        <div className="col self-inspect-col-right">
                            <div className="StepBox self-inspect-instructions-container">
                                <div className="col selfinspect-item-header-container">
                                    {this.props.profile.selectedPersonalCover && this.props.profile.selectedPersonalCover.product === 1 &&
                                        <h3 className="selfinspect-item-header">Car inspection</h3>
                                    }
                                    {
                                        this.props.profile.selectedPersonalCover && this.props.profile.selectedPersonalCover.product === 7 &&
                                        <h3 className="selfinspect-item-header">Motorbike inspection</h3>
                                    }
                                    <p className="selfinspect-item-header-description">{this.props.profile.selectedPersonalCover.riskItems[0].description}</p>
                                </div>
                                <div className="selfinspect-item-header-divider"></div>
                                <div id="SelfInspectSwitchMobile" className="row selfinspect-instructions-container-row">
                                    <div className="col selfinspect-instructions-left-col">
                                        <div className="selfinspect-instructions-header-container">
                                            <h3 className="selfinspect-instructions-header">Switch to your phone </h3>
                                            <p className="selfinspect-instructions-header-description">To self-inspect, please use your phone</p>
                                        </div>
                                        <div className="selfinspect-instructions-steps-container">
                                            {(this.props.profile.countryId !== Number(SA_COUNTRY_ID) || !this.props.ssp.selfInspectionEnabled) && <>
                                                <p className="selfinspect-instructions-steps-p">Follow these steps:</p>
                                                <ul className="selfinspect-instructions-ul">
                                                    <li>
                                                        <span className="selfinspect-instructions-step">Step 1</span>
                                                        <br />
                                                        On your phone or tablet, open your browser and type this into the search bar: {this.props.profile.countryId === Number(SA_COUNTRY_ID) ? 'kingprice.co.za/my-policy' : 'kingprice.co.na/my-policy'}
                                                    </li>
                                                    <li>
                                                        <span className="selfinspect-instructions-step">Step 2</span>
                                                        <br />
                                                        Log into your account
                                                    </li>
                                                    <li>
                                                        <span className="selfinspect-instructions-step">Step 3</span>
                                                        <br />
                                                        On the menu, select ‘{this.props.profile.countryId !== Number(SA_COUNTRY_ID) ? "personal policy" : "personal insurance"}’, then select the car/motorbike you want to self-inspect
                                                    </li>
                                                    <li>
                                                        <span className="selfinspect-instructions-step">Step 4</span>
                                                        <br />
                                                        Tap on the ‘Self-inspection required’ button to start the inspection
                                                    </li>
                                                </ul>
                                            </>}
                                            {(this.props.profile.countryId === Number(SA_COUNTRY_ID) && this.props.ssp.selfInspectionEnabled) && <>
                                                <p className="selfinspect-instructions-steps-p">Tap on the button below to open the self-service portal on your phone (you’ll get an SMS with instructions):</p>
                                                <button id='SwitchToPhoneInspection' onClick={this.handleContinueMobile} className="btn btn-solid-red switch-to-phone-button mb-20px mt-20px">Switch over to my phone</button>
                                            </>}
                                            {this.props.profile.countryId === Number(SA_COUNTRY_ID) &&
                                                <>
                                                    <hr className="selfinspect-instructions-footer-divider" />
                                                    <p className="nomanopa font-size-12px line-height-normal">
                                                        Or, you can self-inspect via our app. Tap <a href="https://www.kingprice.co.za/app" target="_blank" className="selfinspect-instructions-a">here</a> to download it.
                                                    </p>
                                                </>
                                            }
                                        </div>
                                    </div>
                                    <div className="col selfinspect-instructions-right-col">
                                        <Image className="selfinspect-instructions-mobile-img" src="./images/SelfInspect/self-inspection-mobile-example-185x371.png" alt="Self Inspection on Mobile" title="Self Inspection on Mobile" />
                                    </div>
                                </div>
                            </div>

                            <NeedHelp
                                isSelfInspect={true}
                                countryId={this.props.profile.countryId}
                                claimsEmail={this.props.ssp.claims_email}
                                contactUsTel={this.props.ssp.contactUs_tel}
                                handleCallMeBack={(e) => this.props.handleCallMeBack(e)}
                            />
                        </div>
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile,
        selfInspect: state.selfInspect,
        ssp: state.ssp
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchGetSelfInspectPhotos: () => dispatch(getSelfInspectPhotos()),
        dispatchShowSendContinueOnPhone: (phoneNumber) => dispatch(showSendContinueOnPhone(phoneNumber, true)),
        handleCallMeBack: () => dispatch(showCallMeModal(true)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MonthlyMileageDashboard);
